function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRuppeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6490",
    transform: "translate(-1763 -1748)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1105",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(1763 1748)",
    style: {
      fill: "#d9d9d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59310",
    d: "M-530.843 381.768h-2.506a4.14 4.14 0 0 1-.674-.048.908.908 0 0 1-.766-.839.943.943 0 0 1 .632-1.032 1.7 1.7 0 0 1 .585-.074h2.733c-.37-.557-.7-.983-1.391-.971a8.27 8.27 0 0 1-1.817-.046.905.905 0 0 1-.748-.942.929.929 0 0 1 .745-.948 1.7 1.7 0 0 1 .377-.048c1.921 0 3.842-.008 5.763 0a1 1 0 0 1 1.115 1.008 1.013 1.013 0 0 1-1.1.982 3.616 3.616 0 0 0-.507.008c-.15.027-.4-.147-.439.135-.053.395.219.814.486.821.212 0 .425-.011.635.009a.979.979 0 0 1 .927.976.869.869 0 0 1-.866.954 1.353 1.353 0 0 0-1.434.939 2.935 2.935 0 0 1-1.918 1.43l-.372.11 2.053 1.939c.185.175.381.339.549.529a.967.967 0 0 1-.019 1.34.957.957 0 0 1-1.372.049q-2.146-2.016-4.268-4.059a.978.978 0 0 1-.24-1.165.976.976 0 0 1 .989-.589c.593 0 1.187 0 1.78-.005a1.558 1.558 0 0 0 1.068-.463z",
    transform: "translate(2306.031 1377.179)",
    style: {
      fill: "#848484"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuppeIcon);
export default __webpack_public_path__ + "static/media/ruppe_icon.396c801b2f49a0a236ac502f3b024685.svg";
export { ForwardRef as ReactComponent };